import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BusinessCard from "./components/BusinessCard";

function App() {
  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(145deg, #0f172a 0%, #030712 50%, #0a1628 100%)' }}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BusinessCard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
